"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPixels = toPixels;
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
/* eslint-disable import/prefer-default-export */

/**
 * Will append numbers with 'px'.
 * For props where we want to accept either numbers, percentages, em, etc.
 */
function toPixels(number) {
  if ((0, _isNumber["default"])(number)) {
    return "".concat(number, "px");
  }
  return number;
}
//# sourceMappingURL=styling.js.map